import { z } from 'zod';

import { Id, IsoDateTime } from '../common/primitives';

export const NoteTypeSchema = z.enum(['REFUND', 'WARRANTY', 'SHIPPING', 'RETURN', 'PAYMENT', 'GENERAL']);
export type NoteType = z.infer<typeof NoteTypeSchema>;

export const NoteAuthorKindSchema = z.enum(['IN_HOUSE', 'SELLER']);
export type NoteAuthorKind = z.infer<typeof NoteAuthorKindSchema>;

export const NoteSchema = z.object({
  id: Id,
  type: NoteTypeSchema,
  description: z.string(),
  authorKind: NoteAuthorKindSchema,
  authorId: z.string().nullable(),
  vendorId: z.string().nullable(),
  sellerCanAccess: z.boolean(),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
});
export type Note = z.infer<typeof NoteSchema>;

export const CreateNoteRequest = z
  .object({
    type: NoteTypeSchema,
    description: z.string().trim().min(1).max(900),
    authorKind: NoteAuthorKindSchema.optional(),
    sellerCanAccess: z.boolean().optional(),
  })
  .strict();
export type CreateNoteRequest = z.infer<typeof CreateNoteRequest>;

export const UpdateNoteRequest = z
  .object({
    type: NoteTypeSchema.optional(),
    description: z.string().trim().min(1).max(900).optional(),
    sellerCanAccess: z.boolean().optional(),
  })
  .strict();
export type UpdateNoteRequest = z.infer<typeof UpdateNoteRequest>;

export const ListNotesQuery = z
  .object({
    authorKind: NoteAuthorKindSchema.optional(),
    q: z.string().trim().max(200).optional(),
  })
  .strict();
export type ListNotesQuery = z.infer<typeof ListNotesQuery>;

export const NoteSettingSchema = z.object({
  sellerCanAddNote: z.boolean(),
  updatedAt: IsoDateTime,
});
export type NoteSetting = z.infer<typeof NoteSettingSchema>;

export const UpdateNoteSettingRequest = z
  .object({ sellerCanAddNote: z.boolean() })
  .strict();
export type UpdateNoteSettingRequest = z.infer<typeof UpdateNoteSettingRequest>;
